import Vue from 'vue'

Vue.filter('dateIsoToLocale', function (value) {
  try {
    if(!value) return value
    value = value.substring(0, 10)
    return value.split('-').reverse().join('/')
  }
  catch (e) {
      return value
  }
})

Vue.filter('fixed3', function (value) {
  return value.toFixed(3)
})
